import {MembersPageState} from '../types/state'

export const isLoading = (state: MembersPageState) => state.loading
